// client/src/modules/huddle/nav.ts
import type { NavItem } from '../types';

/**
 * Navigation items for Huddle module sidebar.
 * Mirrors the 6 v1 sections on HuddleLanding (Rocks deferred per 5/11).
 */
export const navItems: NavItem[] = [
  { label: 'Dashboard', path: '/huddle' },
  { label: 'Meetings', path: '/huddle/meetings' },
  { label: 'Action Items', path: '/huddle/action-items' },
  { label: 'Decisions', path: '/huddle/decisions' },
  { label: 'Announcements', path: '/huddle/announcements' },
  { label: 'Vision & Strategy', path: '/huddle/vto' },
  { label: 'Accountability', path: '/huddle/accountability' },
];
